<template>
  <div>
    <section class="pt-125 md:pt-175 lg:pt-200 mb-100">
      <div class="container">
        <div class="max-w-screen-xl mx-auto">
          <breadcrumb :breadcrumbs="[data?.overview, data?.entry].filter((b) => b)" />

          <h1
            v-if="data?.entry?.heading"
            class="wysiwyg-title text-3xl md:text-4xl text-secondary mt-50"
            v-html="data.entry.heading"
          />

          <div class="grid md:grid-cols-2">
            <h2
              v-if="data?.entry?.heading2"
              class="wysiwyg-title text-4xl md:text-5xl lg:text-6xl xl:text-7xl md:-ml-150 md:translate-x-150 text-primary-500"
              v-html="data.entry.heading2"
            />
            <div class="md:row-span-3">
              <img
                v-if="data?.entry?.image.length"
                :src="data.entry.image[0].url"
                :srcset="data.entry.image[0].srcset"
                sizes="(max-width: 600px) 345px, (max-width: 1024px) 497px, 100vw"
                :alt="data.entry.title"
                width="1280"
                height="1330"
                class="mt-[-63px] md:mt-100 w-full"
              >
            </div>
            <div
              v-if="data?.entry?.intro"
              class="mt-25 md:pr-50 lg:pr-100 text-lg wysiwyg"
              v-html="data.entry.intro"
            />
          </div>
        </div>
        <div
          v-if="data?.entry?.text"
          class="my:50 lg:my-100"
        >
          <div class="grid grid-cols-6">
            <div class="col-span-4 col-start-2">
              <div
                class="wysiwyg"
                v-html="data.entry.text"
              />
            </div>
          </div>
        </div>
        <h3
          v-if="data?.entry?.heading3"
          class="wysiwyg-title text-3xl md:text-4xl text-secondary mt-50 lg:mt-100"
          v-html="data.entry.heading3"
        />
        <div class="flex flex-wrap -mx-10 lg:-mx-15">
          <div
            v-for="product in data?.products"
            :key="`product-${product.id}`"
            class="w-1/2 md:w-1/3 px-10 lg:px-15 mt-50"
          >
            <product :product="product" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import {
  useI18n,
  useAsyncGql,
  useSeo,
  watch,
  useRoute,
} from '#imports';

// Data
const { locale } = useI18n({ useScope: 'global' });
const route = useRoute();
const { data } = await useAsyncGql('brand', {
  site: locale.value,
  uri: route.path.substring(1).replace(/\/+$/, ''),
});

// Watcher
watch(data, (value) => {
  if (value?.entry?.seomatic) {
    useSeo(value.entry.seomatic);
  }
}, { immediate: true });
</script>
